import { useSearchBox } from 'react-instantsearch'

import type { SearchBoxConnectorParams } from 'instantsearch.js/es/connectors/search-box/connectSearchBox'
import type { ReactElement } from 'react'
import type { GroupBase } from 'react-select'
import type { SelectComponents } from 'react-select/dist/declarations/src/components'

import TextInput from '~/components/Inputs/Basic/TextInput'

export interface Props {
  autoFocus?: boolean
  className?: string
  components?: Partial<SelectComponents<unknown, boolean, GroupBase<unknown>>>
  defaultValue?: string
  focus?: boolean
  icon?: ReactElement
  label?: string
  onChange?: (value: IOption) => void
  placeholder?: string
  wrapperClassName?: string
}

const AlgoliaSearch = ({
  autoFocus = false,
  className,
  defaultValue,
  icon,
  label,
  placeholder,
  wrapperClassName,
  ...props
}: SearchBoxConnectorParams & Props): ReactElement => {
  const { refine } = useSearchBox(props)

  return (
    <TextInput
      autoFocus={autoFocus}
      className={className}
      defaultValue={defaultValue}
      icon={icon}
      label={label}
      onChange={(e) => refine(e.target.value)}
      placeholder={placeholder}
      wrapperClassName={wrapperClassName}
    />
  )
}

export default AlgoliaSearch
